"use client";

import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WillkommenImBodyconcept() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const handleScrollDown = () => {
    const nextSection = document.getElementById("willkommen-im-bodyconcept")?.nextElementSibling;
    if (nextSection) {
      nextSection.scrollIntoView({
        behavior: "smooth"
      });
    } else {
      window.scrollTo({
        top: window.innerHeight,
        behavior: "smooth"
      });
    }
  };
  return <section id="willkommen-im-bodyconcept" className="dark text-foreground relative w-full overflow-hidden bg-background !opacity-[1] bg-cover bg-center !bg-[url(https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/04/bodyconcept_headermotiv-scaled.jpg)] !text-2xl" style={{
    height: "auto",
    minHeight: "800px"
  }}>
      <span className="sr-only">Willkommen im</span>
      <div className="absolute inset-0 w-full h-full">
        <video src="/video/hero.mp4" autoPlay muted loop playsInline className="w-full h-full object-cover" style={{
        filter: "brightness(0.75) saturate(1.1)"
      }} />
        <div className="absolute inset-0 bg-black/40" />
      </div>

      <div ref={contentRef} className="relative z-10 flex flex-col items-center justify-center min-h-[800px] px-4 py-20 text-center">
        <div className="mb-2 transition-all duration-700 delay-75 opacity-100 translate-y-0">
          <span className="text-white/60 tracking-[0.3em] uppercase font-default !font-light !text-3xl">ERLEBE</span>
        </div>
        <div className="mb-6 transition-all duration-700 delay-100 opacity-100 translate-y-0">
          <span style={{
          color: 'rgb(255, 255, 255)',
          fontSize: 'clamp(2.2rem, 7vw, 6rem)',
          letterSpacing: '-0.02em'
        }}>BODYCONCEP T</span>
        </div>
        <div className="transition-all duration-700 delay-200 opacity-100 translate-y-0">
          <h1 className="font-default text-white leading-tight !font-normal !text-[28px]" style={{
          fontSize: 'clamp(2.2rem, 7vw, 6rem)',
          textShadow: 'rgba(0, 0, 0, 0.45) 0px 2px 32px',
          letterSpacing: '-0.02em'
        }}>in&nbsp; Allendorf / Eder</h1>
        </div>
        <div className="mt-4 mb-8 transition-all duration-700 delay-350 opacity-100 translate-y-0">
          
        </div>
        <div className="max-w-xl mb-8 transition-all duration-700 delay-500 opacity-100 translate-y-0">
          <p className="font-default text-white/80 leading-relaxed !text-xl !w-[660px]" style={{
          fontSize: 'clamp(0.95rem, 2vw, 1.15rem)',
          textShadow: 'rgba(0, 0, 0, 0.5) 0px 1px 8px'
        }}>Ganzheitliches Wohlbefinden in Allendorf (Eder): Deine Expertin für Körper und Schönheit. Erlebe wirkungsvolle Anwendungen, maßgeschneidert für dein persönliches Ziel.</p>
        </div>
        <div className="transition-all duration-700 delay-600 opacity-100 translate-y-0">
          <a href="#loesungen" className="font-default text-white border-white/40 bg-white/10 backdrop-blur-sm border px-10 py-4 rounded-lg transition-all duration-300 !text-base hover:bg-white/20 hover:border-white/70">
            MEHR ENTDECKEN
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2">
        <span className="text-white/40 text-[10px] tracking-[0.2em] uppercase mb-1">SCROLL</span>
        <div className={`transition-all duration-700 delay-800 ${isVisible && !scrolled ? "opacity-100" : "opacity-0"}`}>
          <div className="flex flex-col items-center gap-1">
            <div className="w-px bg-white/60" style={{
            height: "48px",
            animation: "scrollLineGrow 1.8s ease-in-out infinite"
          }} />
            <ChevronDown className="text-white/60" size={16} style={{
            animation: "scrollBounce 1.8s ease-in-out infinite"
          }} />
          </div>
        </div>
      </div>

      <style>{`
        :root, .light, .dark {
          --font-script: "Dancing Script", cursive;
          --font-serif: var(--font-script);
        }

        @keyframes scrollLineGrow {
          0% { transform: scaleY(0.3); opacity: 0.3; }
          50% { transform: scaleY(1); opacity: 0.9; }
          100% { transform: scaleY(0.3); opacity: 0.3; }
        }
        @keyframes scrollBounce {
          0%, 100% { transform: translateY(0px); opacity: 0.5; }
          50% { transform: translateY(4px); opacity: 1; }
        }
      `}</style>
    </section>;
}